import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-form-wrapper flex-grow-1 py-s5 lg:py-s8 mx-auto" }

import { useInterval } from '@/composables/utils/useInterval';
import VestingData from '@/views/vesting/VestingData.vue';
import EarnMorePanel from '@/views/vesting/EarnMorePanel.vue';
import ClaimForm from '@/views/vesting/claimForm/ClaimForm.vue';
import NotListed from '@/views/errors/NotListed.vue';
import { useVesting } from '@/composables/core/useVesting';
import { UPDATE_VESTING_TIMEOUT } from '@/constants/UPDATE_VESTING_TIMEOUT';
import ReceivedAll from '@/views/errors/ReceivedAll.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isReceivedAll, updateVesting, isNotListed } = useVesting();

useInterval(updateVesting, UPDATE_VESTING_TIMEOUT);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isNotListed))
      ? (_openBlock(), _createBlock(NotListed, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(VestingData),
          (_unref(isReceivedAll))
            ? (_openBlock(), _createBlock(ReceivedAll, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(ClaimForm, { class: "mt-s3" }),
                _createVNode(EarnMorePanel, { class: "mt-s3" })
              ], 64))
        ], 64))
  ]))
}
}

})